import { SecureStoragePlugin } from "capacitor-secure-storage-plugin";
export const setSecureStorageToken = async (value) => {
    await SecureStoragePlugin.set({ key: "token", value });
};
export const getSecureStorageToken = async () => {
    try {
        const value = await SecureStoragePlugin.get({ key: "token" });
        return value;
    }
    catch (error) {
        console.log("Item with specified key does not exist.");
        await setSecureStorageToken("");
    }
};
export const removeSecureStorageToken = async () => {
    const token = await SecureStoragePlugin.remove({ key: "token" });
    return token;
};
